import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

const EquipmentForm = ({ formData, setFormData }) => {
  return (
    <div className="space-y-4 max-h-[60vh] overflow-y-auto pr-2">
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="name">Name *</Label>
          <Input
            id="name"
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            placeholder="20ft Standard Container"
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="code">Code *</Label>
          <Input
            id="code"
            value={formData.code}
            onChange={(e) => setFormData({ ...formData, code: e.target.value })}
            placeholder="20GP"
          />
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="mode">Transport Mode *</Label>
          <Select value={formData.mode} onValueChange={(v) => setFormData({ ...formData, mode: v })}>
            <SelectTrigger>
              <SelectValue placeholder="Select mode" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="air">Air</SelectItem>
              <SelectItem value="ocean">Ocean</SelectItem>
              <SelectItem value="road">Road</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <div className="space-y-2">
          <Label htmlFor="category">Category *</Label>
          <Input
            id="category"
            value={formData.category}
            onChange={(e) => setFormData({ ...formData, category: e.target.value })}
            placeholder="Dry Container"
          />
        </div>
      </div>

      <div className="space-y-2">
        <Label>Dimensions (cm)</Label>
        <div className="grid grid-cols-3 gap-2">
          <Input
            type="number"
            placeholder="Length"
            value={formData.dimensions.length_cm || ''}
            onChange={(e) => setFormData({
              ...formData,
              dimensions: { ...formData.dimensions, length_cm: parseInt(e.target.value) || 0 }
            })}
          />
          <Input
            type="number"
            placeholder="Width"
            value={formData.dimensions.width_cm || ''}
            onChange={(e) => setFormData({
              ...formData,
              dimensions: { ...formData.dimensions, width_cm: parseInt(e.target.value) || 0 }
            })}
          />
          <Input
            type="number"
            placeholder="Height"
            value={formData.dimensions.height_cm || ''}
            onChange={(e) => setFormData({
              ...formData,
              dimensions: { ...formData.dimensions, height_cm: parseInt(e.target.value) || 0 }
            })}
          />
        </div>
      </div>

      <div className="space-y-2">
        <Label>Capacity</Label>
        <div className="grid grid-cols-2 gap-2">
          <div>
            <Label className="text-xs text-steel-500">Max Weight (kg)</Label>
            <Input
              type="number"
              value={formData.capacity.max_weight_kg || ''}
              onChange={(e) => setFormData({
                ...formData,
                capacity: { ...formData.capacity, max_weight_kg: parseInt(e.target.value) || 0 }
              })}
            />
          </div>
          <div>
            <Label className="text-xs text-steel-500">Max Volume (cbm)</Label>
            <Input
              type="number"
              step="0.1"
              value={formData.capacity.max_volume_cbm || ''}
              onChange={(e) => setFormData({
                ...formData,
                capacity: { ...formData.capacity, max_volume_cbm: parseFloat(e.target.value) || 0 }
              })}
            />
          </div>
        </div>
      </div>

      <div className="space-y-2">
        <Label htmlFor="recommended_use">Recommended Use (comma separated)</Label>
        <Textarea
          id="recommended_use"
          value={formData.recommended_use.join(', ')}
          onChange={(e) => setFormData({
            ...formData,
            recommended_use: e.target.value.split(',').map(s => s.trim()).filter(Boolean)
          })}
          placeholder="General cargo, Dry goods, Electronics"
          rows={2}
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="restrictions">Restrictions (comma separated)</Label>
        <Textarea
          id="restrictions"
          value={formData.restrictions.join(', ')}
          onChange={(e) => setFormData({
            ...formData,
            restrictions: e.target.value.split(',').map(s => s.trim()).filter(Boolean)
          })}
          placeholder="No hazardous materials, Temperature sensitive goods"
          rows={2}
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="image_url">Image URL (optional)</Label>
        <Input
          id="image_url"
          value={formData.image_url || ''}
          onChange={(e) => setFormData({ ...formData, image_url: e.target.value })}
          placeholder="https://example.com/image.jpg"
        />
      </div>
    </div>
  );
};

export default EquipmentForm;
